<template>
 <div>
   <div class="vx-row">
     <vs-button @click="onClickGoBack"  button="submit" color="warning" type="border" size="small" class="mt-2 mb-8 float-left">Go Back to supplier sites</vs-button>
<!--     <vs-button v-if="siteData.is_approved !== 2" @click="openApprovalConfirm" button="submit" class="ml-auto mt-2 mb-8 float-right">Approve Site</vs-button>-->
<!--     <vs-button v-if="siteData.is_approved === 2" @click="openNotApprovalConfirm" button="submit" class="ml-auto mt-2 mb-8 float-right" color="danger">Not Approve Site</vs-button>-->
     <vs-switch class="float-right ml-auto" v-on:input="onChangeStatus" v-model="approved">
       <span slot="on">Site currently approved</span>
       <span slot="off">Site not currently approved</span>
     </vs-switch>
   </div>
   <div class="vx-row">
     <vs-tabs v-if="is_page_load" v-model="activeTab" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">
       <!-- GENERAL -->
       <vs-tab  icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'General' : ''">
         <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
           <supplier-manufacturing-home v-on:notify="notify($event)"/>
         </div>
       </vs-tab>
       <vs-tab v-if="!siteData.is_GFSI_accreditation" icon-pack="feather" icon="icon-user-check" :label="!isSmallerScreen ? 'Employee Details' : ''">
         <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
           <supplier-manufacturing-employee v-on:notify="notify($event)"/>
         </div>
       </vs-tab>
       <vs-tab v-if="!siteData.is_GFSI_accreditation" icon-pack="feather" icon="icon-grid" :label="!isSmallerScreen ? 'Site Details' : ''">
         <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
           <supplier-manufacturing-site-details v-on:notify="notify($event)"/>
         </div>
       </vs-tab>
       <vs-tab v-if="!siteData.is_GFSI_accreditation" icon-pack="feather" icon="icon-check" :label="!isSmallerScreen ? 'Quality Management System' : ''">
         <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
           <supplier-manufacturing-quality v-on:notify="notify($event)" />
         </div>
       </vs-tab>
       <vs-tab v-if="!siteData.is_GFSI_accreditation" icon-pack="feather" icon="icon-cloud-drizzle" :label="!isSmallerScreen ? 'Environmental' : ''">
         <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
           <supplier-manufacturing-environment v-on:notify="notify($event)"/>
         </div>
       </vs-tab>
       <vs-tab v-if="!siteData.is_GFSI_accreditation" icon-pack="feather" icon="icon-check-square" :label="!isSmallerScreen ? 'Ethical' : ''">
         <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
           <supplier-manufacturing-ethical v-on:notify="notify($event)"/>
         </div>
       </vs-tab>
       <vs-tab icon-pack="feather" icon="icon-shield-off" :label="!isSmallerScreen ? 'Allergens' : ''">
         <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
           <supplier-manufacturing-allergens v-on:notify="notify($event)"/>
         </div>
       </vs-tab>
       <vs-tab v-if="!siteData.is_GFSI_accreditation" icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'HACCP' : ''">
         <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
           <supplier-manufacturing-haccp v-on:notify="notify($event)"/>
         </div>
       </vs-tab>
       <vs-tab v-if="!siteData.is_GFSI_accreditation" icon-pack="feather" icon="icon-circle" :label="!isSmallerScreen ? 'Hygiene' : ''">
         <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
           <supplier-manufacturing-hygiene v-on:notify="notify($event)"/>
         </div>
       </vs-tab>
       <vs-tab v-if="!siteData.is_GFSI_accreditation" icon-pack="feather" icon="icon-triangle" :label="!isSmallerScreen ? 'Pest Control' : ''">
         <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
           <supplier-manufacturing-pest v-on:notify="notify($event)"/>
         </div>
       </vs-tab>
       <vs-tab v-if="!siteData.is_GFSI_accreditation" icon-pack="feather" icon="icon-package" :label="!isSmallerScreen ? 'Transport & Storage' : ''">
         <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
           <supplier-manufacturing-transport v-on:notify="notify($event)"/>
         </div>
       </vs-tab>
       <vs-tab v-if="!siteData.is_GFSI_accreditation" icon-pack="feather" icon="icon-shield" :label="!isSmallerScreen ? 'Health & Safety' : ''">
         <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
           <supplier-manufacturing-health-safety v-on:notify="notify($event)"/>
         </div>
       </vs-tab>
       <vs-tab icon-pack="feather" icon="icon-star" :label="!isSmallerScreen ? 'Product Authenticity & Traceability' : ''">
         <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
           <supplier-manufacturing-authenticity/>
         </div>
       </vs-tab>
     </vs-tabs>
   </div>
 </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  const SupplierRepository = RepositoryFactory.get('supplier');

  import SupplierManufacturingHome from './SupplierManufacturingHome.vue'
  import SupplierManufacturingEmployee from './SupplierManufacturingEmployee.vue'
  import SupplierManufacturingSiteDetails from './SupplierManufacturingSiteDetails.vue'
  import SupplierManufacturingQuality from './SupplierManufacturingQuility.vue'
  import SupplierManufacturingEnvironment from './SupplierManufacturingEnvironment.vue'
  import SupplierManufacturingEthical from './SupplierManufacturingEthical.vue'
  import SupplierManufacturingAllergens from './SupplierManufacturingAllergens.vue'
  import SupplierManufacturingHaccp from './SupplierManufacturingHaccp.vue'
  import SupplierManufacturingPest from './SupplierManufacturingPest.vue'
  import SupplierManufacturingTransport from './SupplierManufacturingTransport.vue'
  import SupplierManufacturingHealthSafety from './SupplierManufacturingHealthSafety.vue'
  import SupplierManufacturingAuthenticity from './SupplierManufacturingAuthenticity.vue'
  import SupplierManufacturingHygiene from './SupplierManufacturingHygiene.vue'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')


  export default {
    components: {
      SupplierManufacturingHome,
      SupplierManufacturingEmployee,
      SupplierManufacturingSiteDetails,
      SupplierManufacturingQuality,
      SupplierManufacturingEnvironment,
      SupplierManufacturingEthical,
      SupplierManufacturingAllergens,
      SupplierManufacturingHaccp,
      SupplierManufacturingPest,
      SupplierManufacturingTransport,
      SupplierManufacturingHealthSafety,
      SupplierManufacturingAuthenticity,
      SupplierManufacturingHygiene
    },
    data () {
      return {
        activeTab: 0,
        id: null,
        status: {},
        index: null,
        siteData: {

        },
        approved: false,
        is_page_load: false
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      notify() {
        this.activeTab++
      },
      async checkStepFactory() {
        return Object.entries(this.status).forEach(([key, value], index) => {
          if (value === 0) {
            return index--
          }
        });
      },
      async loadData(){
        this.id = this.$route.params.id
        const {data} = (await SupplierManufactureRepository.getManufactureDetails(this.id)).data
        this.siteData = data
        if(this.siteData.is_approved === 2){
          this.approved = true
        }else if(this.siteData.is_approved !== 2) {
          this.approved = false
        }
      },
      openApprovalConfirm() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Confirm',
          text: 'Are you sure you want to approve this site?',
          accept: this.onClickApproveSupplier,
          cancel: this.onClickCancelApproveSupplier,
        })
      },
      openNotApprovalConfirm() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm',
          text: 'Are you sure you want to suspend this site?',
          accept: this.onClickNotApproveSupplier,
          cancel: this.onClickCancelApproveSupplier,
        })
      },
      onClickGoBack() {
        this.$router.push({path: `/pages/manage-nimble/suppliers/${this.$route.params.supplierId}`, query: {step: '2'}})
        // this.$router.go(-1)
      },
      async onClickApproveSupplier() {
        const vue = this;
        this.$vs.loading();
        try {
          await SupplierRepository.approveSupplierSite(this.id)
          this.showSuccessMessage('The selected site was successfully approved');
        } catch (e) {
          if(e.response.data.status) {
            this.showErrorMessage(e.response.data.status)
          } else {
            this.convertAndNotifyError(e)
          }
        }
        await this.loadData()
        this.$vs.loading.close();
      },
      async onClickNotApproveSupplier() {
        const vue = this;
        this.$vs.loading();
        try {
          await SupplierRepository.NotApproveSite(this.id)
          this.showSuccessMessage('The selected site was successfully not approved');
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        await this.loadData()
        this.$vs.loading.close();
      },
      onClickCancelApproveSupplier() {
        this.approved = !this.approved
      },
      onChangeStatus() {
        if (this.approved) {
          this.openApprovalConfirm()
        } else {
          this.openNotApprovalConfirm()
        }
      }
    },
    async mounted() {
      await this.loadData()
      this.is_page_load = true
    },
    async beforeCreate() {
      this.is_page_load = false
      return null;
    },
    computed: {
      isSmallerScreen () {
        return this.$store.state.windowWidth < 768
      }
    }
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
